import { connect, ConnectedProps } from 'react-redux';

import { MessageType } from 'dashboard/lib/interfaces/Message';
import { clearMessages, showMessage } from 'dashboard/redux/actions/messages';
import { RootState } from 'dashboard/redux/store';
import { updateStripePaymentMethod } from 'dashboard/redux/thunk-actions/organization';
import DashboardOrganizationBillingPaymentView from 'dashboard/views/DashboardOrganizationBillingPaymentView';
import useApiCallback from 'lib/hooks/useApiCallback';
import useApiErrorHandler from 'lib/hooks/useApiErrorHandler';
import { isPermissionsError, permissionsErrorMessage } from 'lib/permissions-errors';

const DashboardOrganizationBillingPaymentRoute = ({
  organization,
  updateStripePaymentMethod,
  clearMessages,
  showMessage,
}: PropsFromRedux) => {
  const { callback: updateStripePaymentMethodId, error: updateStripePaymentMethodError } =
    useApiCallback(async (paymentMethoId: string) => {
      clearMessages();
      await updateStripePaymentMethod(paymentMethoId);
      showMessage('Billing information successfully updated.', MessageType.Success);
    }, []);

  useApiErrorHandler({
    error: updateStripePaymentMethodError,
    onError: (error) => {
      if (isPermissionsError(error)) {
        showMessage(permissionsErrorMessage(error), MessageType.Failure);
      } else {
        showMessage('Billing information failed to update. Please try again.', MessageType.Failure);
      }
    },
    onNetworkError: () =>
      showMessage(
        'Sorry, something went wrong. Please try again later or contact support.',
        MessageType.Failure,
      ),
  });

  return (
    <DashboardOrganizationBillingPaymentView
      currentPaymentMethodDetails={organization.attributes['billing-info']}
      updatePaymentMethod={updateStripePaymentMethodId}
      showMessage={showMessage}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  organization: state.organization.organization,
});

const mapDispatchToProps = {
  updateStripePaymentMethod,
  clearMessages,
  showMessage,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DashboardOrganizationBillingPaymentRoute);
